import createAsyncAction from 'shared/utils/createAsyncAction';
import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';

import createAction from './';
import * as services from '../../services/createMessagingAppointment';

export const CREATE_MESSAGING_APPOINTMENT = createAsyncAction(createAction('CREATE_MESSAGING_APPOINTMENT'));

export const createMessagingAppointment = body => dispatch => {
  dispatch({ type: CREATE_MESSAGING_APPOINTMENT.pending });

  const apiCallParams = {
    mutation: services.CREATE_MESSAGING_APPOINTMENT,
    variables: body,
  };

  return apiCall(apolloClient.mutate, apiCallParams).then(
    ({ data: { createMessagingConsultation: result } }) =>
      dispatch({
        type: CREATE_MESSAGING_APPOINTMENT.success,
        payload: result,
      }),
  );
};
